import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import AboutBannerImg from '../assets/images/sell-banner.png';
import ArrowIcon from '../assets/images/button-arrow.svg';
import { Link } from "react-router-dom"
import {ASSETS_URL} from "../api/constants";

const SellBanner = ({ data, loading }) => {
  return (
    <section className="about-banner-section">
      <Row>
        <Col lg={6} md={12} className='about-content-box align-self-center'>
          <div className="about-content">
            <h1
              className="about-title"
              dangerouslySetInnerHTML={{ __html: data?.title || "" }}
            />
            <p className="about-description">{data?.subtitle || ""}</p>
            <Link to={data?.btn_link || '/find-an-agent'} className='custom-bttn style-3 ani-1 right'>
              {data?.btn_name || "Find an Agent"} <img src={ArrowIcon} alt="Arrow Icon" />
            </Link>
          </div>
        </Col>
        <Col lg={6} md={12}>
          <div className="about-image">
            <img
              src={data?.image ? `${ASSETS_URL}/${data.image}` : AboutBannerImg}
              alt="Modern House"
              className="house-img"
            />
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default SellBanner;